import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-company",
  templateUrl: "./med-icon-company.component.html",
})
export class MedIconCompanyComponent extends SvgMixinComponent {}
